<template>
  <div class="wrap">
    <div class="grid">
      <!-- LEFT: Sipariş -->
      <section class="panel">

        <div class="card-area">
          <!-- Ödeme tipi -->
          <div class="choiceRow">
            <button
              class="choiceBtn"
              :class="{ active: paymentType === 'open' }"
              type="button"
              @click="setPaymentType('open')"
            >
              Açık Hesap
            </button>
            <button
              class="choiceBtn"
              :class="{ active: paymentType === 'card' }"
              type="button"
              @click="setPaymentType('card')"
            >
              Hemen Öde (Kredi Kartı)
            </button>
          </div>

          <!-- Sipariş toplamı (değiştirilemez) -->
          <!-- <div class="infoBox">
            <div>
              <div class="k">Sipariş Toplamı</div>
              <div class="v">{{ fmtMoney(orderAmount) }}</div>
            </div>

            <div style="text-align:right">
              <div class="k">Kaynak</div>
              <div class="v muted">Sepet</div>
            </div>
          </div> -->

          <div v-if="cartLoading" class="loadingTxt">
            Sepet tutarı hesaplanıyor...
          </div>

          <div v-else-if="orderAmount <= 0" class="emptyBox">
            Sepet boş görünüyor. Sipariş oluşturmak için sepete ürün ekleyin.
          </div>

          <!-- Kredi kartı alanları sadece “Hemen Öde”de -->
          <div v-if="paymentType === 'card'" class="ccWrap">
            <div class="ccTitle">Kredi Kartı Bilgileri</div>

            <div class="card-3d">
              <div class="card" :class="{ flipped: isFlipped }">
                <div class="face front">
                  <div class="top">
                    <div class="chip"></div>
                    <div class="brandText">{{ brand.name }}</div>
                  </div>
                  <div class="num">{{ numberPreview }}</div>

                  <div class="meta">
                    <div>
                      <div class="lbl">Kart Sahibi</div>
                      <div class="val">{{ namePreview }}</div>
                    </div>
                    <div style="text-align:right">
                      <div class="lbl">SKT</div>
                      <div class="val">{{ expPreview }}</div>
                    </div>
                  </div>
                </div>

                <div class="face back">
                  <div class="mag"></div>
                  <div class="sig">
                    <div class="muted" style="font-size:12px;">CVC</div>
                    <div class="cvc-box">{{ cvcPreview }}</div>
                  </div>
                  <div class="hint">CVC alanına odaklanınca kart arka yüze döner.</div>
                </div>
              </div>
            </div>

            <div class="form">
              <div class="field span2">
                <label>Kart Numarası</label>
                <input
                  class="input"
                  v-model="cardNumber"
                  inputmode="numeric"
                  autocomplete="cc-number"
                  placeholder="•••• •••• •••• ••••"
                  @input="onCardNumberInput"
                  @focus="isFlipped = false"
                />
              </div>

              <div class="field span2">
                <label>Kart Sahibi</label>
                <input
                  class="input"
                  v-model="cardName"
                  autocomplete="cc-name"
                  placeholder="Ad Soyad"
                  @input="onNameInput"
                />
              </div>

              <div class="field">
                <label>Ay</label>
                <select class="input" v-model="expMonth" autocomplete="cc-exp-month" @change="syncExpPreview">
                  <option value="">MM</option>
                  <option v-for="m in 12" :key="'m'+m" :value="pad2(m)">{{ pad2(m) }}</option>
                </select>
              </div>

              <div class="field">
                <label>Yıl</label>
                <select class="input" v-model="expYear" autocomplete="cc-exp-year" @change="syncExpPreview">
                  <option value="">YY</option>
                  <option v-for="yy in yearOptions" :key="'y'+yy" :value="yy">{{ yy }}</option>
                </select>
              </div>

              <div class="field span2">
                <label>CVC</label>
                <input
                  class="input"
                  v-model="cvc"
                  inputmode="numeric"
                  autocomplete="cc-csc"
                  :placeholder="brand.cvc === 4 ? '••••' : '•••'"
                  :maxlength="brand.cvc"
                  @focus="isFlipped = true"
                  @blur="isFlipped = false"
                  @input="onCvcInput"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- MIDDLE: Taksit (sadece Hemen Öde) -->
      <section class="panel">
        <div class="ph">
          <h2>Taksit Seçimi</h2>
          <span class="pill">
            <span class="dot" :class="{ ok: paymentType === 'card' && !!brand.key }"></span>
            <span v-if="paymentType !== 'card'">Açık hesapta taksit yok</span>
            <span v-else>{{ brand.key ? ('Sadece ' + brand.name + ' için') : 'Kart giriniz' }}</span>
          </span>
        </div>

        <div class="mid">
          <div v-if="paymentType === 'card'" class="info">
            <div>
              <div class="k">Uygun Kart</div>
              <div class="v">{{ brand.name }}</div>
            </div>

            <div v-if="binCheckLoading" style="text-align:right;">
              <div class="k">Durum</div>
              <div class="v">Kart sorgulanıyor...</div>
            </div>

            <div v-else-if="binInfo || providerInfo" style="text-align:right;">
              <div class="k">Banka / Provider</div>
              <div class="v">
                {{ currentBankName || '-' }} /
                {{ currentProviderName || '-' }}
              </div>
            </div>
          </div>

          <div v-if="paymentType !== 'card'" class="empty">
            Açık hesap seçildi. Sipariş kaydedilecek, ödeme daha sonra alınacak.
          </div>

          <div v-else-if="!brand.key" class="empty">
            Kart numarasını girince, sadece o karta uygun taksitler listelenecek.
          </div>

          <div v-else class="inst-list">
            <div
              v-for="opt in installmentOptions"
              :key="brand.key + '-' + opt.n"
              class="inst"
              :class="{ selected: selectedInstallment && selectedInstallment.n === opt.n }"
              tabindex="0"
              @click="selectInstallment(opt)"
              @keydown.enter.prevent="selectInstallment(opt)"
              @keydown.space.prevent="selectInstallment(opt)"
            >
              <div class="l">
                <div class="tag">{{ opt.n }}</div>
                <div class="txt">
                  <div class="t1">{{ opt.n === 1 ? 'Tek çekim' : (opt.n + ' taksit') }}</div>
                  <div class="t2">Ek masraf: {{ fmtMoney(opt.feeAmount) }}</div>
                </div>
              </div>

              <div class="r">
                <div class="price">
                  <div class="p1">{{ fmtMoney(opt.monthly) }} / ay</div>
                  <div class="p2">Toplam: {{ fmtMoney(opt.total) }}</div>
                </div>
                <div class="radio" aria-hidden="true"><i></i></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- RIGHT: Ödeme Özeti (logo yok, input yok) -->
      <section class="panel">
        <div class="ph">
          <h2>Ödeme Özeti</h2>
          <span class="pill"><span class="dot ok"></span><span>{{ paymentTypeLabel }}</span></span>
        </div>

        <div class="sum">
          <div class="brandbox">
            <div class="lines">
              <div class="line">
                <div class="k">Bakiye</div>
                <div class="v">{{ fmtMoney(orderAmount) }}</div>
              </div>

              <div class="line">
                <div class="k">Hemen ödeme indirimi</div>
                <div class="v" :class="{ muted: paymentType !== 'card' }">
                  - {{ fmtMoney(discountAmount) }}
                  <span class="muted" style="font-size:12px;">(%{{ immediatelyPayDiscountRate }})</span>
                </div>
              </div>

              <div class="line">
                <div class="k">İndirim sonrası bakiye</div>
                <div class="v">{{ fmtMoney(payableBase) }}</div>
              </div>

              <div class="line">
                <div class="k">Taksit</div>
                <div class="v muted">
                  <span v-if="paymentType !== 'card'">—</span>
                  <span v-else>{{ selectedInstallment ? (selectedInstallment.n === 1 ? 'Tek çekim' : (selectedInstallment.n + ' taksit')) : '—' }}</span>
                </div>
              </div>

              <div class="line">
                <div class="k">Ek Masraf</div>
                <div class="v">{{ fmtMoney(paymentType === 'card' && selectedInstallment ? selectedInstallment.feeAmount : 0) }}</div>
              </div>

              <div class="line">
                <div class="k">Taşıma Bedeli</div>
                <div class="v">{{ fmtMoney(kargoTutar) }}</div>
              </div>

              <div class="line">
                <div class="k">
                  {{ paymentType === 'card' ? 'Kredi kartından çekilecek' : 'Ödenecek (Açık Hesap)' }}
                </div>
                <div class="v">{{ fmtMoney(finalPayable) }}</div>
              </div>
            </div>
          </div>
        <div class="summary-note">
          <label for="siparisNotu">Sipariş notu</label>
          <textarea
            id="siparisNotu"
            v-model="siparisNotu"
            rows="3"
            placeholder="Siparişinizle ilgili not ekleyebilirsiniz"
          ></textarea>
        </div>
          <button class="paybtn" type="button" @click="submitOrder" :disabled="cartLoading || payLoading || orderAmount <= 0">
            {{ paymentType === 'card' ? 'Siparişi Oluştur ve Öde' : 'Siparişi Oluştur (Açık Hesap)' }}
            <span class="lock" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M7 11V8a5 5 0 0 1 10 0v3" stroke="white" stroke-width="2" stroke-linecap="round"/>
                <path d="M6 11h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z" stroke="white" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
          </button>

          <div v-if="cartLoading" class="loadingTxt">Sepet tutarı hesaplanıyor...</div>
        </div>
      </section>
    </div> 
  </div>
</template>

<script>
import db from "../../db";
import fiyatHelper from "../../services/fiyat/yapas.js";

export default {
  name: "OrderCreate",
  data() {
    const now = new Date();
    const y = now.getFullYear();
    return {
      // payment type
      paymentType: "open", // open | card
      items:[],
      siparisNotu: '',

      // sepetten hesaplanan tutar
      cartLoading: false,
      cartAmount: 0,
      kargoSyncing: false,
      kargo:{
        "20":  { fiyat:30000,kod:'602' }
      },

      // sabit indirim oranı (müşteri değiştiremez)
      immediatelyPayDiscountRate: this.$request.ayar().ekiskonto,

      // card
      hesap: this.$request.ayar(),
      cardNumber: "",
      cardName: "",
      expMonth: this.pad2(now.getMonth() + 1),
      expYear: String(y).slice(-2),
      cvc: "",
      isFlipped: false,
      payLoading: false,
      lastBinQueried: "",
      binCheckTimer: null,
      binCheckLoading: false,
      binCheckError: "",
      backendInstallments: [],
      providerInfo: null,
      binInfo: null,

      // previews
      numberPreview: "•••• •••• •••• ••••",
      namePreview: "AD SOYAD",
      expPreview: this.pad2(now.getMonth() + 1) + "/" + String(y).slice(-2),
      cvcPreview: "•••",

      brand: { name: "—", key: null, cvc: 3, group: [4, 4, 4, 4], max: 16 },
      selectedInstallment: null,

      currency: "₺",

      // demo taksit oranları (sonradan sağlayıcıdan gelecek)
      installmentsByBrand: {
        visa: [{ n: 1, fee: 0.0 }, { n: 2, fee: 0.0 }, { n: 3, fee: 0.0 }, { n: 6, fee: 0.05 }, { n: 9, fee: 0.08 }, { n: 12, fee: 0.11 }],
        mc: [{ n: 1, fee: 0.0 }, { n: 2, fee: 0.01 }, { n: 3, fee: 0.02 }, { n: 6, fee: 0.06 }, { n: 9, fee: 0.09 }, { n: 12, fee: 0.12 }],
        amex: [{ n: 1, fee: 0.0 }, { n: 3, fee: 0.03 }, { n: 6, fee: 0.07 }],
        troy: [{ n: 1, fee: 0.0 }, { n: 2, fee: 0.0 }, { n: 3, fee: 0.01 }, { n: 6, fee: 0.04 }, { n: 9, fee: 0.07 }],
        other: [{ n: 1, fee: 0.0 }]
      }
    };
  },

  computed: {
    paymentTypeLabel() {
      return this.paymentType === "card" ? "Hemen Öde" : "Açık Hesap";
    },

    kargoRule() {
      const fid = this.hesap && this.hesap.fid != null ? String(this.hesap.fid) : "";
      if (!fid) return null;
      const rule = this.kargo && this.kargo[fid] ? this.kargo[fid] : null;
      if (!rule) return null;
      const fiyat = Number(rule.fiyat || 0);
      const kod = String(rule.kod || "").trim();
      if (!kod || !fiyat) return null;
      return { fiyat, kod };
    },
    kargoLine() {
      const rule = this.kargoRule;
      if (!rule) return null;
      return (this.items || []).find(it => String(it.kod || "").trim() === rule.kod) || null;
    },
    kargoTutar() {
      if (!this.kargoLine) return 0;
      const adet = Number(this.kargoLine.adet || 0) || 0;
      const net = Number(this.kargoLine.fiyat1 || 0) || 0;
      const ara = net * adet;
      const kdv = ara * ((Number(this.kargoLine.kdv || 0) || 0) / 100);
      return ara + kdv;
    },

    // Sipariş toplamı (sepetten)
orderAmount() {
  const v = Number(this.cartAmount);
  return isFinite(v) ? v : 0;
},


    // İndirim sadece hemen öde’de uygulanır
discountAmount() {
  if (this.paymentType !== "card") return 0;

  const base = Number(this.orderAmount);
  const rate = Number(this.immediatelyPayDiscountRate);

  if (!isFinite(base) || base <= 0) return 0;
  if (!isFinite(rate) || rate <= 0) return 0;

  return base * (rate / 100);
},


    // Ödeme hesaplarının temel tutarı (indirim sonrası)
    payableBase() {
      const after = this.orderAmount - this.discountAmount;
      return after < 0 ? 0 : after;
    },

    yearOptions() {
      const now = new Date();
      const y = now.getFullYear();
      const arr = [];
      for (let i = 0; i < 12; i++) arr.push(String(y + i).slice(-2));
      return arr;
    },

    installmentOptions() {
      if (this.paymentType !== "card") return [];
      if (!this.brand.key) return [];
      const base = Number(this.payableBase || 0);

      if (Array.isArray(this.backendInstallments) && this.backendInstallments.length) {
        return this.backendInstallments.map((r) => {
          const n = Number(r.installment || r.n || 1);
          const total = Number(r.total || base) || base;
          const monthly = Number(r.monthly || (n ? (total / n) : total)) || 0;
          const feeAmount = Number(r.feeAmount || 0) || 0;
          const rate = Number(r.rate || 0) || 0;
          return { n, total, monthly, feeAmount, rate, meta: r.meta || null };
        });
      }

      const raw = this.installmentsByBrand[this.brand.key] || this.installmentsByBrand.other;
      return raw.map((r) => {
        const total = base * (1 + r.fee);
        const monthly = r.n ? total / r.n : total;
        const feeAmount = total - base;
        return { ...r, total, monthly, feeAmount };
      });
    },

    finalPayable() {
      if (this.paymentType !== "card") {
        // açık hesapta ödeme alınmayacak; yine de ödenecek bakiye olarak toplamı gösteriyoruz
        return this.orderAmount;
      }
      return this.selectedInstallment ? this.selectedInstallment.total : this.payableBase;
    },

    currentBankName() {
      if (Array.isArray(this.installmentOptions) && this.installmentOptions.length) {
        const m = this.installmentOptions[0] && this.installmentOptions[0].meta ? this.installmentOptions[0].meta : null;
        if (m && (m.BankName || m.bankName || m.bank_name)) return m.BankName || m.bankName || m.bank_name;
      }
      if (this.binInfo && (this.binInfo.bank_name || this.binInfo.bankName)) return this.binInfo.bank_name || this.binInfo.bankName;
      if (this.binInfo && this.binInfo.name) return this.binInfo.name;
      return "";
    },

    currentProviderName() {
      if (this.providerInfo && this.providerInfo.name) return this.providerInfo.name;
      if (this.providerInfo && this.providerInfo.provider_name) return this.providerInfo.provider_name;
      if (this.providerInfo && this.providerInfo.code) return this.providerInfo.code;
      if (this.providerInfo && this.providerInfo.provider_code) return this.providerInfo.provider_code;
      return "";
    }
  },

  watch: {
    // sepet tutarı / indirim sonrası tutar değişirse taksit yeniden set
    payableBase() {
      this.ensureDefaultInstallment();
    },
    "brand.key"() {
      this.ensureDefaultInstallment();
    },
    paymentType() {
      this.ensureDefaultInstallment();
      if (this.paymentType !== "card") this.isFlipped = false;
    },
    '$store.aktifCari'(cari) {
      if (cari && Array.isArray(cari.basket)) {
        this.loadCartAmountLikeSepet();
      }
    }
  },

  async created() {
    await this.loadCartAmountLikeSepet();
    this.syncExpPreview();
    this.$store.setLoading([false,'Bekleyiniz'])

  },

  methods: {
    setPaymentType(t) {
      this.paymentType = t;
    },

    ensureDefaultInstallment() {
      if (this.paymentType === "card" && this.brand.key && this.installmentOptions.length) {
        this.selectedInstallment = this.installmentOptions[0];
      } else {
        this.selectedInstallment = null;
      }
    },

    buildOrderNo() {
      return "SP-" + Date.now();
    },

    buildClientOrderReference() {
      return "SPREF-" + Date.now();
    },

    getReturnUrl(orderNo, clientOrderReference) {
      const providerCode = String(
        (this.providerInfo && (this.providerInfo.code || this.providerInfo.provider_code)) ||
        "finrota"
      ).toLowerCase();

      // Banka/3D sayfalari query parametrelerini hash'in onune ekleyebiliyor (SPA hash route bozuluyor).
      // Bu yuzden 3D returnUrl'i backend callback'e veriyoruz. Backend de bizi tekrar frontend'e yonlendiriyor.
      // Prod ortaminda port eklenmemeli; request client domain'i varsa onu kullan.
      const requestDomain = (this.$request && this.$request.domain) ? String(this.$request.domain) : "";
      const apiOrigin = requestDomain
        ? requestDomain.replace(/\/+$/, "")
        : (window.location.protocol + "//" + window.location.hostname + ":3003");

      const fe =
        window.location.origin +
        window.location.pathname +
        "#/siparis/tahsilat_sonuc";

      const fe64 = btoa(unescape(encodeURIComponent(fe)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");

      return (
        apiOrigin +
        "/payment/callback/" +
        encodeURIComponent(providerCode) +
        "?orderNo=" +
        encodeURIComponent(orderNo || "") +
        "&ref=" +
        encodeURIComponent(clientOrderReference || "") +
        "&fe64=" +
        encodeURIComponent(fe64)
      );
    },

    pad2(n) {
      return String(n).padStart(2, "0");
    },
    onlyDigits(s) {
      return (s || "").replace(/\D/g, "");
    },
    fmtMoney(n) {
      const x = Number(n || 0);
      return this.currency + " " + x.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

async loadCartAmountLikeSepet() {
  this.cartLoading = true;

  try {
    const aktifCari = this.$store.aktifCari;

    // reset
    this.items = [];
    this.cartAmount = 0;

    if (!aktifCari || !Array.isArray(aktifCari.basket) || !aktifCari.basket.length) {
      return;
    }

    // Aynı guid birden fazla kez gelirse UI/tutar çiftlenmesin: tekilleştir.
    const basketMap = new Map();
    for (const b of aktifCari.basket) {
      if (!b || b.guid == null) continue;
      const key = String(b.guid);
      const prev = basketMap.get(key);
      if (!prev) {
        basketMap.set(key, { ...b });
      } else {
        const a1 = Number(prev.adet || 0) || 0;
        const a2 = Number(b.adet || 0) || 0;
        basketMap.set(key, { ...prev, adet: a1 + a2, note: (b.note != null ? b.note : prev.note) });
      }
    }
    const basket = Array.from(basketMap.values());

    // basket -> ids (guid)
    const ids = basket.map(b => b.guid).filter(Boolean);
    if (!ids.length) return;

    // stocks fetch (Dexie)
    let stocks = [];
    try {
      stocks = await db.stocks.where("id").anyOf(ids).toArray();
    } catch (e) {
      // fallback
      stocks = await db.stocks.toCollection().filter(s => ids.includes(s.id)).toArray();
    }

    // map by id
    const map = {};
    stocks.forEach(s => {
      map[String(s.id)] = s;
    });

    let sumAra = 0;
    let sumKdv = 0;

    // Aynı stok birden fazla guid ile sepete düşmüşse (aynı kod), kod bazında tekilleştir.
    const basketByKod = new Map();
    for (const row of basket) {
      const guidKey = String(row && row.guid != null ? row.guid : "");
      if (!guidKey) continue;
      const stock = map[guidKey];
      if (!stock) continue;
      const kodKey = String(stock.kod || stock.stokkodu || "").trim();
      if (!kodKey) {
        basketByKod.set("guid:" + guidKey, row);
        continue;
      }
      const prev = basketByKod.get(kodKey);
      if (!prev) basketByKod.set(kodKey, row);
      else {
        const a1 = Number(prev.adet || 0) || 0;
        const a2 = Number(row.adet || 0) || 0;
        basketByKod.set(kodKey, { ...prev, adet: a1 + a2, note: (row.note != null ? row.note : prev.note) });
      }
    }

    for (const row of Array.from(basketByKod.values())) {
      const stock = map[String(row.guid)];
      if (!stock) continue;
var carpan = Number(stock.carpan || 1);

      const adet = Number(row.adet*carpan) || 0;
      if (adet <= 0) continue;

      const kdvOran = Number(stock.kdv || 0);
      // sepet.vue ile aynı mantık: net fiyat için fiyatHelper
      const extra = { fiyat: (stock.fiyat/carpan).toFixed(2), kdv: kdvOran };

      const fiyatDetay = await fiyatHelper.getFiyat(
        extra,
        this.$helper,
        this.hesap.kdvli,
        this.$store.aktifCari.iskontokod,0,stock.doviz || 0
      );
      const listeFiyat = Number(fiyatDetay && fiyatDetay.liste) || 0;
      const netFiyat =
        (fiyatDetay && typeof fiyatDetay.iskontolu === "number")
          ? Number(fiyatDetay.iskontolu)
          : listeFiyat;

      // toplam hesap (sepet.vue pratik mantığı)
      const ara = netFiyat * adet;
      const kdvTutar = ara * (kdvOran / 100);

      sumAra += ara;
      sumKdv += kdvTutar;

      // iskonto array'ini 3 eleman garanti et
      const isk = (fiyatDetay && Array.isArray(fiyatDetay.iskonto)) ? fiyatDetay.iskonto : [];
      const i0 = isk[0] || {};
      const i1 = isk[1] || {};
      const i2 = isk[2] || {};

      // items -> senin istediğin şema
      this.items.push({
        id: stock.id || row.guid,
        adet: adet,
        note: (row.note !== undefined && row.note !== null) ? row.note : 0,

        isim: stock.isim || stock.adi || stock.ad || stock.stokadi || "",
        marka: stock.marka || "",
        kod: stock.kod || stock.stokkodu || "",
        foto: stock.foto || stock.resim || stock.gorsel || (stock.kod || stock.stokkodu || ""),
        depo:stock.depo || "",
        kdv: kdvOran,
        birim: stock.birim || "",

        fiyat1:netFiyat,

        fiyat: {
          liste: listeFiyat,
          iskontolu: netFiyat,
          iskonto: [
            {
              oran: Number(i0.oran || 0),
              tutar: (i0.tutar !== undefined && i0.tutar !== null) ? Number(i0.tutar) : netFiyat,
              fark: Number(i0.fark || 0)
            },
            {
              oran: Number(i1.oran || 0),
              tutar: (i1.tutar !== undefined && i1.tutar !== null) ? Number(i1.tutar) : netFiyat,
              fark: Number(i1.fark || 0)
            },
            {
              oran: Number(i2.oran || 0),
              tutar: (i2.tutar !== undefined && i2.tutar !== null) ? Number(i2.tutar) : netFiyat,
              fark: Number(i2.fark || 0)
            }
          ]
        }
      });
    }

    this.cartAmount = sumAra + sumKdv;
  } finally {
    this.cartLoading = false;
  }

  await this.ensureKargo();
},

    async ensureKargo() {
      const rule = this.kargoRule;
      if (!rule) return;
      if (this.kargoSyncing) return;

      const kargoKod = rule.kod;

      const baseTotal = (this.items || [])
        .filter(it => String(it.kod || "").trim() !== kargoKod)
        .reduce((sum, it) => {
          const adet = Number(it && it.adet ? it.adet : 0) || 0;
          const net = Number(it && it.fiyat1 ? it.fiyat1 : 0) || 0;
          const ara = net * adet;
          const kdv = ara * ((Number(it && it.kdv ? it.kdv : 0) || 0) / 100);
          return sum + ara + kdv;
        }, 0);

      const shouldHaveKargo = baseTotal < Number(rule.fiyat || 0);
      const hasKargo = !!(this.items || []).find(it => String(it.kod || "").trim() === kargoKod);

      if (shouldHaveKargo && !hasKargo) {
        this.kargoSyncing = true;
        try {
          const stok = await db.stocks.where("kod").equals(String(kargoKod)).first();
          if (!stok || stok.id == null) return;

          const cari = this.$store.aktifCari;
          if (!cari || !cari.kod || !cari.guid) return;

          const obje = { giden: this.$helper.point(cari.kod, [], [], [], stok.id, '', 1, 0, 0, 0, 'isim', 'asc', 1), adet: 1, durum: 1, note: "" };
          const res = await this.$request.post('basket/update', obje);
          if (!res || res.status == 300 || res.status == 503) return;

          const yeniBasket = Array.isArray(cari.basket) ? cari.basket.slice() : [];
          if (!yeniBasket.find(x => x && x.guid === stok.id)) {
            yeniBasket.push({ guid: stok.id, adet: 1, updateAt: new Date().toISOString() });
            await db.caris.update(cari.guid, { basket: yeniBasket });
            this.$store.aktifCari.basket = yeniBasket;
          }

          await this.loadCartAmountLikeSepet();
        } finally {
          this.kargoSyncing = false;
        }
        return;
      }

      if (!shouldHaveKargo && hasKargo) {
        this.kargoSyncing = true;
        try {
          const cari = this.$store.aktifCari;
          if (!cari || !cari.kod || !cari.guid) return;

          const kargoItem = (this.items || []).find(it => String(it.kod || "").trim() === kargoKod);
          if (!kargoItem) return;

          await this.$request.post("basket/delete", { cKod: cari.kod, guid: kargoItem.id });

          const yeniBasket = Array.isArray(cari.basket) ? cari.basket.filter(x => x && x.guid !== kargoItem.id) : [];
          await db.caris.update(cari.guid, { basket: yeniBasket });
          this.$store.aktifCari.basket = yeniBasket;

          await this.loadCartAmountLikeSepet();
        } finally {
          this.kargoSyncing = false;
        }
      }
    },

    // Kart / maskeleme
    detectBrand(digits) {
      if (!digits) return { name: "—", key: null, cvc: 3, group: [4, 4, 4, 4], max: 16 };
      if (/^4/.test(digits)) return { name: "VISA", key: "visa", cvc: 3, group: [4, 4, 4, 4], max: 16 };
      if (/^(5[1-5])/.test(digits) || /^(2(2[2-9]|[3-6]\d|7[01]|720))/.test(digits)) return { name: "MASTERCARD", key: "mc", cvc: 3, group: [4, 4, 4, 4], max: 16 };
      if (/^(34|37)/.test(digits)) return { name: "AMEX", key: "amex", cvc: 4, group: [4, 6, 5], max: 15 };
      if (/^9792/.test(digits)) return { name: "TROY", key: "troy", cvc: 3, group: [4, 4, 4, 4], max: 16 };
      return { name: "KART", key: "other", cvc: 3, group: [4, 4, 4, 4], max: 16 };
    },
    formatByGroups(digits, groups) {
      let out = [];
      let i = 0;
      for (const g of groups) {
        if (i >= digits.length) break;
        out.push(digits.slice(i, i + g));
        i += g;
      }
      if (i < digits.length) out.push(digits.slice(i));
      return out.join(" ");
    },
    maskedPreview(digits, brand) {
      const shown = digits.slice(-4);
      const maskedLen = Math.max(0, Math.min(digits.length, brand.max) - 4);
      const masked = "•".repeat(maskedLen) + shown;
      return this.formatByGroups(masked, brand.group);
    },

    syncExpPreview() {
      const mm = this.expMonth || "MM";
      const yy = this.expYear || "YY";
      this.expPreview = `${mm}/${yy}`;
    },
    onNameInput() {
      const v = (this.cardName || "").trim().toUpperCase();
      this.namePreview = v ? v : "AD SOYAD";
    },
    onCvcInput() {
      const d = this.onlyDigits(this.cvc).slice(0, this.brand.cvc);
      this.cvc = d;
      this.cvcPreview = d ? "•".repeat(Math.max(0, d.length - 1)) + d.slice(-1) : this.brand.cvc === 4 ? "••••" : "•••";
    },
    onCardNumberInput(e) {
      const input = e.target;
      const start = input.selectionStart || 0;
      const before = input.value;
      const digitsBefore = this.onlyDigits(before.slice(0, start)).length;

      const digitsRaw = this.onlyDigits(this.cardNumber);
      const b = this.detectBrand(digitsRaw);
      this.brand = b;

      this.scheduleBinCheck();

      const digits = digitsRaw.slice(0, b.max);
      this.cardNumber = this.formatByGroups(digits, b.group);
      this.numberPreview = digits.length ? this.maskedPreview(digits, b) : "•••• •••• •••• ••••";

      this.$nextTick(() => {
        const after = input.value;
        let pos = 0,
          seen = 0;
        while (pos < after.length && seen < digitsBefore) {
          if (/\d/.test(after[pos])) seen++;
          pos++;
        }
        input.setSelectionRange(pos, pos);
      });
    },

    scheduleBinCheck() {
      if (this.paymentType !== "card") return;
      const bin = this.onlyDigits(this.cardNumber).slice(0, 8);

      if (bin.length < 6) {
        this.backendInstallments = [];
        this.providerInfo = null;
        this.binInfo = null;
        this.binCheckError = "";
        this.lastBinQueried = "";
        return;
      }
      if (!this.payableBase || this.payableBase <= 0) return;

      if (this.lastBinQueried === bin && this.backendInstallments.length) return;

      if (this.binCheckTimer) clearTimeout(this.binCheckTimer);
      this.binCheckTimer = setTimeout(() => {
        this.fetchBinInfo();
      }, 450);
    },

    async fetchBinInfo() {
      const bin = this.onlyDigits(this.cardNumber).slice(0, 8);
      if (bin.length < 6) return;
      if (!this.payableBase || this.payableBase <= 0) return;

      this.binCheckLoading = true;
      this.binCheckError = "";

      try {
        const payload = {
          bin: bin,
          amount: Number(this.payableBase || 0),
          currency: "TRY"
        };

        const res = await this.$request.post("payment/bin-check", payload);
        const data = res && res.data ? res.data : res;

        if (!data || data.success === false) {
          throw new Error((data && data.message) || "BIN sorgusu başarısız");
        }

        this.lastBinQueried = bin;
        this.binInfo = data.bank || null;
        this.providerInfo = data.provider || null;
        this.backendInstallments = Array.isArray(data.installments) ? data.installments : [];

        if (this.backendInstallments.length) {
          this.selectedInstallment = this.installmentOptions[0] || null;
        } else {
          this.selectedInstallment = null;
          this.binCheckError = "Bu kart için kullanılabilir taksit bulunamadı";
        }
      } catch (err) {
        console.error("BIN_CHECK_ERROR", err);
        this.backendInstallments = [];
        this.selectedInstallment = null;
        this.binInfo = null;
        this.providerInfo = null;
        this.binCheckError =
          (err && err.message) ||
          "Kart bilgisi okunamadı, lütfen tekrar deneyin";
      } finally {
        this.binCheckLoading = false;
      }
    },

    selectInstallment(opt) {
      this.selectedInstallment = {
        n: Number(opt.n || 1),
        feeAmount: Number(opt.feeAmount || 0),
        total: Number(opt.total || this.payableBase || 0),
        monthly: Number(opt.monthly || 0),
        rate: Number(opt.rate || 0),
        meta: opt.meta || null
      };
    },

    async submitOrder() {
      const errs = [];
      if (this.orderAmount <= 0) errs.push("Sepet boş. Sipariş oluşturulamaz.");

      if (this.paymentType === "card") {
        const numDigits = this.onlyDigits(this.cardNumber);
        const nm = (this.cardName || "").trim();
        const mm = this.expMonth;
        const yy = this.expYear;
        const cv = this.onlyDigits(this.cvc);

        const b = this.detectBrand(numDigits);
        if (!b.key) errs.push("Kart numarası giriniz.");
        else if (numDigits.length !== b.max) errs.push("Kart numarası eksik/uygunsuz.");
        if (!nm) errs.push("Kart sahibi gerekli.");
        if (!mm || !yy) errs.push("Son kullanım tarihi gerekli.");
        if (cv.length !== b.cvc) errs.push("CVC eksik.");
        if (!this.selectedInstallment) errs.push("Taksit seçimi gerekli.");
      }

      if (errs.length) {
        alert(errs.join("\n"));
        return;
      }

      this.$store.setLoading([true, "Lütfen bekleyiniz"]);

      try {
        sessionStorage.setItem(
          "siparis_draft",
          JSON.stringify({
            createdAt: Date.now(),
            paymentType: this.paymentType,
            siparisNotu: this.siparisNotu || "",
            items: this.items || [],
            cari: {
              guid: (this.$store && this.$store.aktifCari && this.$store.aktifCari.guid) || "",
              kod: (this.$store && this.$store.aktifCari && this.$store.aktifCari.kod) || "",
              unvan: (this.$store && this.$store.aktifCari && this.$store.aktifCari.unvan) || "",
              basket: (this.$store && this.$store.aktifCari && this.$store.aktifCari.basket) || []
            }
          })
        );
      } catch (e) { }

      if (this.paymentType !== "card") {
        this.$router.push({ path: "/siparis/tahsilat_sonuc", query: { mode: "open" } });
        return;
      }

      await this.payInit();
    },

    async payInit() {
      if (this.payLoading) return;

      this.payLoading = true;
      this.$store.setLoading([true, "Lütfen bekleyiniz"]);
      try {
        const orderNo = this.buildOrderNo();
        const clientOrderReference = this.buildClientOrderReference();
        const returnUrl = this.getReturnUrl(orderNo, clientOrderReference);

        const aktifCari = (this.$store && this.$store.aktifCari) || {};
        const carid = (aktifCari.guid || "");
        const customerEmail = (aktifCari.mail || aktifCari.email || "").trim();
        const customerPhone = (aktifCari.gsm || "").trim();
        const baslik = (aktifCari.unvan || "").trim();
        const vno = (aktifCari.vno || "").trim();

        const payload = {
          amount: Number(this.payableBase || 0),
          feeAmount: 0,
          installment: Number(this.selectedInstallment ? this.selectedInstallment.n : 1),
          currency: "TRY",
          returnUrl: returnUrl,
          clientOrderReference: clientOrderReference,
          orderNo: orderNo,
          payment_source: "siparis",
          customer_vkn: vno,
          customer: {
            name: baslik,
            email: customerEmail,
            phone: customerPhone,
            carid: carid,
            tckn: vno
          },
          order: {
            description: "Sipariş tahsilat"
          },
          customer_message: "Sipariş tahsilat",
          card: {
            holder: (this.cardName || "").trim(),
            number: this.onlyDigits(this.cardNumber),
            expMonth: this.expMonth,
            expYear: this.expYear,
            cvc: this.onlyDigits(this.cvc)
          }
        };

        const res = await this.$request.post("payment/init", payload);
        const data = res && res.data ? res.data : res;

        if (!data || data.success === false) {
          throw new Error((data && data.message) || "Ödeme başlatılamadı");
        }

        try {
          sessionStorage.setItem(
            "siparis_payment_meta",
            JSON.stringify({
              createdAt: Date.now(),
              orderNo: data.orderNo || orderNo,
              clientOrderReference: clientOrderReference
            })
          );
        } catch (e) { }

        if (data.mode === "redirect" && data.redirectUrl) {
          document.location = data.redirectUrl;
          return;
        }

        if (data && data.mode === "html_form") {
          if (!data.html) throw new Error("3D form boş geldi");
          var wrapper = document.createElement("div");
          wrapper.innerHTML = data.html;
          document.body.appendChild(wrapper);
          var formEl = wrapper.querySelector("form");
          if (!formEl) throw new Error("3D form bulunamadı");
          setTimeout(function () { formEl.submit(); }, 50);
          return;
        }

        this.$router.push({
          path: "/siparis/tahsilat_sonuc",
          query: { orderNo: data.orderNo || orderNo, status: data.status || "3d_pending" }
        });
      } catch (err) {
        console.error("PAY_INIT_ERROR", err);
        const msg =
          (err && err.response && err.response.data && (err.response.data.message || err.response.data.error)) ||
          (err && err.data && (err.data.message || err.data.error)) ||
          (err && err.message) ||
          "Ödeme başlatılırken hata oluştu";
        alert(String(msg));
      } finally {
        this.payLoading = false;
        this.$store.setLoading([false, ""]);
      }
    },
async siparisekle(arr) {
  const result = await this.$swal({
    title: "Onaylıyor musunuz?",
    text: "Siparişi Ekliyorum ...",
    icon: "warning",
    // showCancelButton: true,
    confirmButtonText: "Evet",
    showCloseButton: true,
    showLoaderOnConfirm: true,
  });

  if (!result || !result.value) return;

  this.$store.setLoading([true, "Bekleyiniz"]);

  try {
    const obj = {
      odeme: "1", // açık hesap
      cKod: this.$store.aktifCari.kod, // 'MS.001050',
      notu: this.siparisNotu,
      id: "123456", // tahsilatlar için
      depo: "",
      teslim: 0, // req.body.teslim,
      entegrekodu: this.hesap.entegrekodu,
      ekler: this.hesap.iskonto + "#" + this.hesap.ekiskonto + "#" + this.hesap.kmail,
      satir: this.items,
    };


    // post'u await ile al
    const response = await this.$request.post(this.hesap.program + "/sipekle", obj);

    // response yoksa çık
    // if (!Array.isArray(response) || !response.length) {
    //   throw new Error("Sipariş cevabı boş veya hatalı.");
    // }
    if (response.status == 300) {
            this.$store.setLoading([false,'Bekleyiniz'])
            this.$router.push("/oturum")    
    }
    // cari referansı
    const cari = this.$store.aktifCari;

    // başarılı olanları tek seferde toplayıp tek update yapmak daha sağlıklı
    const successGuids = [];

    // Sıralı işle (forEach değil)
    for (const e of response) {
      console.log(e);
      if (e && e.status) {
        successGuids.push(e.guid);
      }
    }

    if (successGuids.length) {
      // basketten çıkar
      const yeniBasket = (cari.basket || []).filter((it) => !successGuids.includes(it.guid));

      // Dexie update mutlaka await
      await db.caris.update(cari.guid, { basket: yeniBasket }); 
      this.$store.aktifCari.basket = yeniBasket;

      // items listesinden de çıkar
      this.items = (this.items || []).filter((x) => !successGuids.includes(x.id));
    }

    const bildirimObje = {
      tip: 1,
      alias: "Sipariş",
      renk: "success",
      link: "siparis",
      seri: response[0].seri,
      sira: response[0].sira,
      kid: this.hesap.kid,
      baslik: this.$store.aktifCari.unvan,
      ckod: this.$store.aktifCari.kod,
      names: this.hesap.kad, // sadece mail için
    };

    await this.$request.post("crm/bildirim/add", bildirimObje);

    this.$store.showNotify({
      type: "success",
      text: `Sipariş Ekleme Başarılı`,
      timeout: 3000,
    });
    setTimeout(() => {
      this.$store.setLoading([false,'Bekleyiniz'])
      this.$router.push("/siparis/list")
    }, 1500);
  } catch (err) {
    console.error(err);

    this.$store.showNotify({
      type: "danger",
      text: `Sipariş eklenemedi: ${err && err.message ? err.message : "Bilinmeyen hata"}`,
      timeout: 4000,
    });
  } finally {
    this.$store.setLoading([false, "Bekleyiniz"]);
  }
}

  }
};
</script>

<style scoped>
/* önceki ödeme tasarımı ile aynı tema */
.wrap { max-width: 1320px; margin: 22px auto; padding: 0 14px; }
.grid { display: grid; grid-template-columns: 1.1fr 1fr .85fr; gap: 16px; align-items: start; }
@media (max-width: 1100px) { .grid { grid-template-columns: 1fr; } }

.panel { background: #fff; border: 1px solid #e8ecf5; border-radius: 18px; box-shadow: 0 14px 40px rgba(16,24,40,.10); overflow: hidden; margin-bottom:15px }
.ph { padding: 14px 16px; border-bottom: 1px solid #e8ecf5; background: linear-gradient(180deg,#fff,#fbfcff); display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.ph h2 { margin: 0; font-size: 13px; letter-spacing: .2px; text-transform: uppercase; color: #64748b; font-weight: 600; }

.pill { display: inline-flex; align-items: center; gap: 8px; padding: 7px 10px; border-radius: 999px; border: 1px solid #dfe6f3; background: #fff; font-weight: 600; font-size: 12px; color: #334155; }
.dot { width: 9px; height: 9px; border-radius: 999px; background: #cbd5e1; }
.dot.ok { background: #16a34a; }

.card-area { padding: 16px; display: grid; gap: 12px; }

.choiceRow { display: flex; gap: 10px; }
.choiceBtn { flex: 1; border: 1px solid #dfe6f3; background: #fff; border-radius: 14px; padding: 12px 10px; font-weight: 600; cursor: pointer; }
.choiceBtn.active { border-color: rgba(29,78,216,.35); box-shadow: 0 0 0 4px rgba(29,78,216,.10); background: #f2f5ff; }

.infoBox { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px; border-radius: 16px; border: 1px solid #e8ecf5; background: linear-gradient(180deg,#f7f9ff,#fff); }
.k { font-size: 12px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: .3px; }
.v { font-size: 13px; font-weight: 600; color: #0f172a; }
.muted { color: #64748b; font-weight: 600; }

.loadingTxt { color: #64748b; font-size: 12px; font-weight: 600; }
.emptyBox { border: 1px dashed #dfe6f3; border-radius: 16px; padding: 14px 12px; background: #fff; color: #64748b; font-weight: 600; font-size: 13px; }

.ccWrap { border-top: 1px solid rgba(232,236,245,.7); padding-top: 12px; }
.ccTitle { font-size: 12px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: .3px; margin-bottom: 8px; }

.input { border-radius: 14px; border: 1px solid #dfe6f3; background: #f7f9ff; padding: 12px 12px; outline: none; font-weight: 600; color: #0f172a; }
.input:focus { background: #fff; border-color: rgba(29,78,216,.35); box-shadow: 0 0 0 4px rgba(29,78,216,.12); }

.card-3d { width: 100%; max-width: 420px; aspect-ratio: 1.58 / .70; perspective: 1200px; }
.card { width: 100%; height: 100%; position: relative; transform-style: preserve-3d; transition: transform .6s cubic-bezier(.2,.9,.2,1); }
.card.flipped { transform: rotateY(180deg); }
.face {
  position: absolute; inset: 0; border-radius: 18px; border: 1px solid rgba(15,23,42,.10);
  overflow: hidden; backface-visibility: hidden;
  background:
    radial-gradient(520px 240px at 20% 0%, rgba(16,42,87,.18), transparent 55%),
    radial-gradient(620px 320px at 90% 80%, rgba(99,102,241,.10), transparent 55%),
    linear-gradient(135deg, rgba(255,255,255,.88), rgba(245,248,255,.86));
  box-shadow: 0 18px 40px rgba(15,23,42,.10);
}
.front { padding: 18px; }
.top { display: flex; align-items: center; gap: 12px; }
.chip { width: 54px; height: 40px; border-radius: 12px; border: 1px solid rgba(15,23,42,.10); background: linear-gradient(180deg, rgba(15,23,42,.07), rgba(15,23,42,.03)); }
.brandText { margin-left: auto; font-weight: 600; letter-spacing: 1px; font-size: 12px; color: rgba(15,23,42,.70); text-transform: uppercase; }
.num { margin-top: 22px; font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace; font-size: 20px; letter-spacing: 1.6px; color: rgba(15,23,42,.82); min-height: 28px; font-weight: 600; }
.meta { margin-top: 18px; display: flex; justify-content: space-between; gap: 18px; }
.lbl { font-size: 11px; text-transform: uppercase; letter-spacing: .6px; color: rgba(100,116,139,.95); font-weight: 600; }
.val { margin-top: 6px; font-size: 14px; font-weight: 600; color: rgba(15,23,42,.82); letter-spacing: .2px; }
.back { transform: rotateY(180deg); }
.mag { margin-top: 18px; height: 42px; background: rgba(15,23,42,.20); }
.sig { margin: 16px 18px 0 18px; height: 44px; border-radius: 12px; border: 1px solid rgba(15,23,42,.10); background: rgba(255,255,255,.70); display: flex; align-items: center; justify-content: flex-end; padding: 0 12px; gap: 10px; }
.cvc-box { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-weight: 600; letter-spacing: 1px; color: rgba(15,23,42,.82); background: rgba(15,23,42,.08); border: 1px solid rgba(15,23,42,.10); padding: 6px 10px; border-radius: 10px; min-width: 66px; text-align: center; }
.hint { margin: 14px 18px; font-size: 12px; color: rgba(100,116,139,.95); font-weight: 600; }

.form { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 10px; }
@media (max-width: 520px) { .form { grid-template-columns: 1fr; } }
.field { display: flex; flex-direction: column; gap: 6px; }
.field label { font-size: 12px; color: #64748b; font-weight: 600; letter-spacing: .2px; }
.span2 { grid-column: 1 / -1; }

.mid { padding: 10px 16px 16px 16px; }
.info { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px; border-radius: 16px; border: 1px solid #e8ecf5; background: linear-gradient(180deg,#f7f9ff,#fff); }
.inst-list { margin-top: 12px; display: grid; gap: 10px; }
.inst { border: 1px solid #e8ecf5; background: #fff; border-radius: 16px; padding: 12px; display: flex; align-items: center; justify-content: space-between; gap: 12px; cursor: pointer; }
.inst:hover { background: #f2f5ff; }
.inst.selected { background: #eef4ff; border-color: rgba(29,78,216,.25); box-shadow: 0 10px 18px rgba(29,78,216,.10); }
.l { display: flex; align-items: center; gap: 12px; min-width: 0; }
.tag { width: 38px; height: 38px; border-radius: 14px; border: 1px solid #dfe6f3; background: linear-gradient(180deg,#fff,#f7f9ff); display: grid; place-items: center; font-weight: 600; color: #0f172a; flex: 0 0 auto; }
.txt { min-width: 0; }
.t1 { font-weight: 600; font-size: 13px; color: #0f172a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.t2 { margin-top: 4px; font-size: 12px; color: #64748b; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.r { display: flex; align-items: center; gap: 10px; flex: 0 0 auto; }
.price { text-align: right; line-height: 1.1; }
.p1 { font-weight: 600; font-size: 13px; color: #0f172a; white-space: nowrap; }
.p2 { margin-top: 4px; font-size: 12px; color: #64748b; font-weight: 600; white-space: nowrap; }
.radio { width: 18px; height: 18px; border-radius: 999px; border: 2px solid #cbd5e1; background: #fff; display: grid; place-items: center; }
.radio i { width: 8px; height: 8px; border-radius: 999px; background: transparent; display: block; }
.inst.selected .radio { border-color: #1d4ed8; }
.inst.selected .radio i { background: #1d4ed8; }

.empty { margin-top: 12px; border: 1px dashed #dfe6f3; border-radius: 16px; padding: 14px 12px; background: #fff; color: #64748b; font-weight: 600; font-size: 13px; }

.sum { padding: 16px; }
.brandbox { border-radius: 18px; border: 1px solid #e8ecf5; background: linear-gradient(180deg,#fff,#fbfcff); padding: 14px; }
.lines { display: grid; gap: 10px; }
.line { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 2px; border-bottom: 1px solid rgba(232,236,245,.55); }
.line:last-child { border-bottom: none; }

.paybtn {
  width: 100%;
  margin-top: 14px;
  border: none;
  border-radius: 16px;
  padding: 14px 14px;
  background: #1d4ed8;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 14px 26px rgba(29,78,216,.22);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.paybtn[disabled]{ opacity:.6; cursor:not-allowed; box-shadow:none; }
.lock { width: 34px; height: 34px; border-radius: 12px; background: rgba(255,255,255,.12); display: grid; place-items: center; margin-left: auto; }
.summary-note {
  margin-top: 12px;
  margin-left:10px
}

.summary-note label {
  font-size: 13px;
  display: block;
  margin-bottom: 4px;
}

.summary-note textarea {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 13px;
  padding: 6px;
  resize: vertical;
}
</style>



// WEBPACK FOOTER //
// src/views/siparis/add.vue